/** Canonical spacing + typography from DESIGN_INTELLIGENCE.md */
export const SPACING = [4, 8, 12, 16, 20, 24, 32, 40, 48, 64];

export const PAGE_PAD = {
  desktop: "16px 20px",
  tablet: "14px 16px",
  mobile: "10px 12px",
};

export const MIN_WIREFRAME_CONTENT_HEIGHT = 320;

/** Fixed wizard flow canvas height per viewport — keeps preview area stable across steps. */
export const WIREFRAME_CANVAS_HEIGHT = {
  desktop: 520,
  tablet: 560,
  mobile: 600,
};

export function canvasHeightForViewport(viewport) {
  if (viewport === "mobile") return WIREFRAME_CANVAS_HEIGHT.mobile;
  if (viewport === "tablet") return WIREFRAME_CANVAS_HEIGHT.tablet;
  return WIREFRAME_CANVAS_HEIGHT.desktop;
}

export const TYPO = {
  hero: { fontSize: 36, fontWeight: 700, lineHeight: 1.15 },
  pageTitle: { fontSize: 18, fontWeight: 600, lineHeight: 1.3 },
  sectionTitle: { fontSize: 13, fontWeight: 600, lineHeight: 1.35 },
  cardTitle: { fontSize: 12, fontWeight: 500, lineHeight: 1.4 },
  body: { fontSize: 12, fontWeight: 400, lineHeight: 1.5 },
  caption: { fontSize: 10, fontWeight: 400, lineHeight: 1.45 },
};

export function pagePadForViewport(viewport) {
  if (viewport === "mobile") return PAGE_PAD.mobile;
  if (viewport === "tablet") return PAGE_PAD.tablet;
  return PAGE_PAD.desktop;
}

/** Central product footer text for ZiniHub Admin + Customer shells. [prefix, brandLinkText, suffix] */
export const PRODUCT_FOOTER = ["ZiniHub\u00A92026 Powered by", "ziniz.online"];
